import { useState } from 'react';
import { useWorkspaceStore } from '../store/workspaceStore';
import { useLayoutStore } from '../store/layoutStore';
import { CollapseHeader } from './CollapseHeader';

/** Right-column panel: toggle/reorder channels and manage saved presets. */
export function ChannelConfig(): React.ReactElement {
  const channelConfig = useWorkspaceStore((s) => s.channelConfig);
  const channelMeta = useWorkspaceStore((s) => s.channelMeta);
  const setVisible = useWorkspaceStore((s) => s.setChannelVisible);
  const reorder = useWorkspaceStore((s) => s.reorderChannel);
  const presets = useWorkspaceStore((s) => s.presets);
  const applyPreset = useWorkspaceStore((s) => s.applyPreset);
  const savePreset = useWorkspaceStore((s) => s.savePreset);
  const deletePreset = useWorkspaceStore((s) => s.deletePreset);
  const channelsCollapsed = useLayoutStore((s) => !!s.collapsed.channels);
  const presetsCollapsed = useLayoutStore((s) => !!s.collapsed.presets);

  const [presetName, setPresetName] = useState('');

  const ordered = [...channelConfig].sort((a, b) => a.order - b.order);

  return (
    <div className="config-panel">
      <CollapseHeader title="Channels" k="channels" />
      {!channelsCollapsed && (
        <>
          {ordered.length === 0 && (
            <div className="list-item muted small">Load a lap to configure channels.</div>
          )}
          <ul className="cfg-list">
            {ordered.map((c) => {
              const meta = channelMeta[c.channelId];
              return (
                <li key={c.channelId} className="cfg-item">
                  <input
                    type="checkbox"
                    checked={c.visible}
                    onChange={(e) => setVisible(c.channelId, e.target.checked)}
                  />
                  <span className="name" title={meta?.name ?? c.channelId}>
                    {meta?.name ?? c.channelId}
                    {meta?.unit ? <span className="muted small"> {meta.unit}</span> : null}
                  </span>
                  <span className="ord">
                    <button onClick={() => reorder(c.channelId, -1)} title="Move up">
                      ▲
                    </button>
                    <button onClick={() => reorder(c.channelId, 1)} title="Move down">
                      ▼
                    </button>
                  </span>
                </li>
              );
            })}
          </ul>
        </>
      )}

      <CollapseHeader title="Presets" k="presets" />
      {!presetsCollapsed && (
        <>
          <ul className="list">
            {presets.map((p) => (
              <li key={p.id} className="cfg-item">
                <span className="name lap-select" onClick={() => applyPreset(p)}>
                  {p.name}
                </span>
                <button className="danger small" onClick={() => void deletePreset(p.id)}>
                  ✕
                </button>
              </li>
            ))}
          </ul>
          <div className="row" style={{ padding: '6px 12px' }}>
            <input
              placeholder="Preset name"
              value={presetName}
              onChange={(e) => setPresetName(e.target.value)}
            />
            <button
              disabled={!presetName.trim() || channelConfig.length === 0}
              onClick={() => {
                void savePreset(presetName.trim());
                setPresetName('');
              }}
            >
              Save
            </button>
          </div>
        </>
      )}
    </div>
  );
}
